import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import content from "@/content/siteContent";

export default function PrivacyPage() {
  const p = content.privacy;
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-plz-deep font-body text-plz-cream">
      <div className="noise-overlay" aria-hidden="true" />
      <div className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:py-32">
        <Link to="/" data-testid="privacy-back-link"
          className="group inline-flex items-center gap-2 font-heading text-sm font-bold text-plz-orange transition-colors hover:text-plz-amber">
          <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" aria-hidden="true" />
          Back to PLZ Company
        </Link>
        <h1 className="mt-10 font-heading text-3xl font-extrabold tracking-tight sm:text-4xl">{p.title}</h1>
        <p className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-plz-muted">{p.updated}</p>
        <div className="mt-12 space-y-10">
          {p.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-heading text-xl font-semibold text-plz-orange">{s.heading}</h2>
              <p className="mt-3 text-base leading-relaxed text-plz-slate">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
